(function () {
  function lazyloadBgs() {
    const lazyBackgrounds = document.querySelectorAll(".lazy-bg[data-bg]");

    if (!("IntersectionObserver" in window) || !lazyBackgrounds.length) return

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.backgroundImage = entry.target.dataset.bg;
          observer.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      observer.observe(lazyBackground);
    });
  }

  lazyloadBgs();
})();